import './ResumeEditor.css';
import React from 'react';
import datafile from "../information/Resume.json";
import GitHubFileUploader from "./GitHubFileUploader";
import Resume from "../components/pages/Resume";

const ResumeEditor = () => {
    const [resumeData, setResumeData] = React.useState(datafile);

    const handleResumeTitleChange = (e) => {
        setResumeData({...resumeData, title: e.target.value});
    };

    const handleResumeImageAdd = () => {
        const newImage = prompt('Enter image URL:');
        if (newImage) {
            setResumeData({...resumeData, carouselImages: [...resumeData.carouselImages, newImage]});
        }
    };

    const handleResumeImageDelete = (index) => {
        const updatedImages = resumeData.carouselImages.filter((_, i) => i !== index);
        setResumeData({...resumeData, carouselImages: updatedImages});
    };

    const handleHeaderFieldChange = (field, subField, value) => {
        setResumeData(prevData => ({
            ...prevData, header: {
                ...prevData.header, [field]: subField ? {...prevData.header[field], [subField]: value} : value
            }
        }));
    };

    const handleTrainerAdd = () => {
        const newTrainer = {
            name: "New Trainer", years: "Start Year - End Year", contact: ""
        };
        setResumeData({...resumeData, trainers: [...resumeData.trainers, newTrainer]});
    };

    const handleTrainerDelete = (index) => {
        const updatedTrainers = resumeData.trainers.filter((_, i) => i !== index);
        setResumeData({...resumeData, trainers: updatedTrainers});
    };

    const handleTrainerFieldChange = (trainerIndex, field, value) => {
        const updatedTrainers = resumeData.trainers.map((trainer, index) => (index === trainerIndex ? {
                ...trainer,
                [field]: value
            } : trainer));
        setResumeData({...resumeData, trainers: updatedTrainers});
    };

    const handleAchievementAdd = (year) => {
        const newAchievement = {
            title: "New Achievement", details: ["New detail..."]
        };
        const updatedAchievements = {...resumeData.achievements};
        updatedAchievements[year] = [...(updatedAchievements[year] || []), newAchievement];
        setResumeData({...resumeData, achievements: updatedAchievements});
    };

    const handleAchievementDelete = (year, index) => {
        const updatedAchievements = {...resumeData.achievements};
        updatedAchievements[year].splice(index, 1);
        setResumeData({...resumeData, achievements: updatedAchievements});
    };

    const handleAchievementFieldChange = (year, index, field, value) => {
        const updatedAchievements = {...resumeData.achievements};
        updatedAchievements[year][index][field] = value;
        setResumeData({...resumeData, achievements: updatedAchievements});
    };

    const handleDetailAdd = (year, index) => {
        const updatedAchievements = {...resumeData.achievements};
        updatedAchievements[year][index].details.push("New detail...");
        setResumeData({...resumeData, achievements: updatedAchievements});
    };

    const handleDetailDelete = (year, achievementIndex, detailIndex) => {
        const updatedAchievements = {...resumeData.achievements};
        updatedAchievements[year][achievementIndex].details.splice(detailIndex, 1);
        setResumeData({...resumeData, achievements: updatedAchievements});
    };

    const handleClinicAdd = () => {
        const newClinic = prompt("Enter new clinic");
        if (newClinic) {
            setResumeData({...resumeData, clinics: [...resumeData.clinics, newClinic]});
        }
    };

    const handleClinicDelete = (index) => {
        const updatedClinics = resumeData.clinics.filter((_, i) => i !== index);
        setResumeData({...resumeData, clinics: updatedClinics});
    };

    const handleShowScheduleAdd = (year) => {
        const newShow = prompt("Enter new show");
        if (newShow) {
            setResumeData(prevData => ({
                ...prevData, showSchedule: {
                    ...prevData.showSchedule, [year]: [...(prevData.showSchedule[year] || []), newShow]
                }
            }));
        }
    };

    const handleShowScheduleDelete = (year, index) => {
        const updatedSchedule = {...resumeData.showSchedule};
        updatedSchedule[year].splice(index, 1);
        setResumeData({...resumeData, showSchedule: updatedSchedule});
    };

    const moveElement = (array, fromIndex, toIndex) => {
        const newArray = [...array];
        const [movedItem] = newArray.splice(fromIndex, 1);
        newArray.splice(toIndex, 0, movedItem);
        return newArray;
    };

    const moveDetail = (year, achievementIndex, detailIndex, direction) => {
        const updatedAchievements = {...resumeData.achievements};
        const details = updatedAchievements[year][achievementIndex].details;
        const newIndex = detailIndex + direction;
        if (newIndex >= 0 && newIndex < details.length) {
            updatedAchievements[year][achievementIndex].details = moveElement(details, detailIndex, newIndex);
            setResumeData({...resumeData, achievements: updatedAchievements});
        }
    };

    const moveTrainer = (index, direction) => {
        const newIndex = index + direction;
        if (newIndex >= 0 && newIndex < resumeData.trainers.length) {
            setResumeData({...resumeData, trainers: moveElement(resumeData.trainers, index, newIndex)});
        }
    };

    const sortedAchievements = Object.keys(resumeData.achievements)
        .sort((a, b) => b - a)
        .reduce((obj, key) => {
            obj[key] = resumeData.achievements[key];
            return obj;
        }, {});

    return (<>
            <div className="json-editor">


                <h2>Resume Editor</h2>

                <div className="editor-section">
                    <label>Title:</label>
                    <input
                        type="text"
                        value={resumeData.title}
                        onChange={handleResumeTitleChange}
                        className="title-input"
                    />
                </div>

                <div className="editor-section">
                    <label>Carousel Images:</label>
                    <ul>
                        {resumeData.carouselImages.map((img, index) => (<li key={index}>
                                {img}
                                <button onClick={() => handleResumeImageDelete(index)}
                                        className="btn btn-danger">Delete
                                </button>
                            </li>))}
                    </ul>
                    <button onClick={handleResumeImageAdd} className="btn btn-primary">Add Image</button>
                </div>

                <div className="editor-section">
                    <label>Header:</label>
                    {Object.entries(resumeData.header).map(([key, value]) => (typeof value === 'object' ? (
                            <div key={key} className="bio-section">
                                <h3>{key}</h3>
                                {Object.entries(value).map(([subKey, subValue]) => (
                                    <div key={subKey} className="bio-field">
                                        <label>{subKey}:</label>
                                        <input
                                            type="text"
                                            value={subValue}
                                            onChange={(e) => handleHeaderFieldChange(key, subKey, e.target.value)}
                                            className="input-field"
                                        />
                                    </div>))}
                            </div>) : (<div key={key} className="bio-field">
                                <label>{key}:</label>
                                <input
                                    type="text"
                                    value={value}
                                    onChange={(e) => handleHeaderFieldChange(key, null, e.target.value)}
                                    className="input-field"
                                />
                            </div>)))}
                </div>

                <div className="editor-section">
                    <label>Trainers:</label>
                    {resumeData.trainers.map((trainer, index) => (<div key={index} className="bio-section">
                            <h3>Trainer {index + 1}</h3>
                            <div className="bio-field">
                                <label>Name:</label>
                                <input
                                    type="text"
                                    value={trainer.name}
                                    onChange={(e) => handleTrainerFieldChange(index, 'name', e.target.value)}
                                    className="input-field"
                                />
                            </div>
                            <div className="bio-field">
                                <label>Years:</label>
                                <input
                                    type="text"
                                    value={trainer.years}
                                    onChange={(e) => handleTrainerFieldChange(index, 'years', e.target.value)}
                                    className="input-field"
                                />
                            </div>
                            <div className="bio-field">
                                <label>Contact:</label>
                                <input
                                    type="text"
                                    value={trainer.contact}
                                    onChange={(e) => handleTrainerFieldChange(index, 'contact', e.target.value)}
                                    className="input-field"
                                />
                            </div>
                            <div className="move-buttons">
                                <button onClick={() => moveTrainer(index, -1)} className="btn btn-secondary">Move Up
                                </button>
                                <button onClick={() => moveTrainer(index, 1)} className="btn btn-secondary">Move Down
                                </button>
                                <button onClick={() => handleTrainerDelete(index)} className="btn btn-danger">Delete
                                </button>
                            </div>
                        </div>))}
                    <button onClick={handleTrainerAdd} className="btn btn-primary">Add Trainer</button>
                </div>

                <div className="editor-section">
                    <label>Achievements:</label>
                    {Object.keys(sortedAchievements).map((year) => (<div key={year} className="bio-section">
                            <h3>{year}</h3>
                            {sortedAchievements[year].map((achievement, index) => (
                                <div key={index} className="bio-section">
                                    <div className="bio-field">
                                        <label>Title:</label>
                                        <input
                                            type="text"
                                            value={achievement.title}
                                            onChange={(e) => handleAchievementFieldChange(year, index, 'title', e.target.value)}
                                            className="input-field"
                                        />
                                    </div>
                                    {achievement.details.map((detail, detailIndex) => (
                                        <div key={detailIndex} className="bio-field">
                                            <label>Detail {detailIndex + 1}:</label>
                                            <input
                                                type="text"
                                                value={detail}
                                                onChange={(e) => {
                                                    const updatedAchievements = {...resumeData.achievements};
                                                    updatedAchievements[year][index].details[detailIndex] = e.target.value;
                                                    setResumeData({...resumeData, achievements: updatedAchievements});
                                                }}
                                                className="input-field"
                                            />
                                            <button
                                                onClick={() => moveDetail(year, index, detailIndex, -1)}
                                                className="btn btn-secondary"
                                                disabled={detailIndex === 0}
                                            >
                                                ▲
                                            </button>
                                            <button
                                                onClick={() => moveDetail(year, index, detailIndex, 1)}
                                                className="btn btn-secondary"
                                                disabled={detailIndex === achievement.details.length - 1}
                                            >
                                                ▼
                                            </button>
                                            <button
                                                onClick={() => handleDetailDelete(year, index, detailIndex)}
                                                className="btn btn-danger"
                                            >
                                                Delete Detail
                                            </button>
                                        </div>))}
                                    <button onClick={() => handleDetailAdd(year, index)}
                                            className="btn btn-secondary">Add Detail
                                    </button>
                                    <button onClick={() => handleAchievementDelete(year, index)}
                                            className="btn btn-danger">Delete Achievement
                                    </button>
                                </div>))}
                            <button onClick={() => handleAchievementAdd(year)} className="btn btn-secondary">Add
                                Achievement
                            </button>
                        </div>))}
                </div>

                <div className="editor-section">
                    <label>Clinics:</label>
                    <ul>
                        {resumeData.clinics.map((clinic, index) => (<li key={index}>
                                {clinic}
                                <button onClick={() => handleClinicDelete(index)} className="btn btn-danger">Delete
                                </button>
                            </li>))}
                    </ul>
                    <button onClick={handleClinicAdd} className="btn btn-primary">Add Clinic</button>
                </div>

                <div className="editor-section">
                    <label>Show Schedule:</label>
                    {Object.keys(resumeData.showSchedule).sort((a, b) => b - a).map((year) => (
                        <div key={year} className="bio-section">
                            <h3>{year}</h3>
                            {resumeData.showSchedule[year].map((show, index) => (<div key={index} className="bio-field">
                                    <label>Show {index + 1}:</label>
                                    <input
                                        type="text"
                                        value={show}
                                        onChange={(e) => {
                                            const updatedSchedule = {...resumeData.showSchedule};
                                            updatedSchedule[year][index] = e.target.value;
                                            setResumeData({...resumeData, showSchedule: updatedSchedule});
                                        }}
                                        className="input-field"
                                    />
                                    <button onClick={() => handleShowScheduleDelete(year, index)}
                                            className="btn btn-danger">Delete Show
                                    </button>
                                </div>))}
                            <button onClick={() => handleShowScheduleAdd(year)} className="btn btn-secondary">Add Show
                            </button>
                        </div>))}
                </div>
            </div>
        <Resume resumeData={resumeData}/>
        <GitHubFileUploader jsonData={resumeData} fileName={"Resume.json"}/>
        </>);
};

export default ResumeEditor;
